import { Alert, Box } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";

export const DeprecatedDomainWarning = (): ReactElement => {
  const OLD_DOMAIN = "beta.climatepartner.com";
  const NEW_DOMAIN = "app.climatepartner.com";
  const [isDeprecatedDomain, setIsDeprecatedDomain] = useState(false);
  useEffect(() => {
    if (window.location.hostname.includes(OLD_DOMAIN)) {
      setIsDeprecatedDomain(true);
    }
  }, []);

  const getNewDomainUrl = (): string => {
    const url = new URL(window.location.toString());
    url.hostname = NEW_DOMAIN;
    return url.toString();
  };

  if (!isDeprecatedDomain) {
    return <></>;
  }
  return (
    <Box sx={{ marginBottom: 2 }}>
      <Alert severity="warning">
        It seems you entered our page on our old domain "{OLD_DOMAIN}" please use{" "}
        <a href={getNewDomainUrl()}>this URL</a> from now on and don't forget to change it in your bookmarks!
      </Alert>
    </Box>
  );
};
